import {
  Typography,
  TextField,
  Button,
  Box,
  Alert,
  CircularProgress,
  Checkbox,
  FormControlLabel,
  Stack,
} from "@mui/material";
import { useEffect, useMemo } from "react";
import { useProfileVersions } from "../Hooks/usePofileVersions";
import ProfileVersion from "../Components/ProfileVersion";
import { ProfileVersionSchema } from "../../common/models/schema/ProfileVersionSchema";

const ProfileVersionsPage = () => {
  const {
    personId,
    loading,
    error,
    handleSubmit,
    handleInputChange,
    versions,
    handleRollback,
    noVersions,
  } = useProfileVersions();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Profile Versions
      </Typography>
      <Typography variant="body1" component="h1" gutterBottom>
        View the profile versions for the selected person.
      </Typography>

      <Box sx={{ maxWidth: 400, mt: 3 }}>
        <TextField
          fullWidth
          label="NATIONBUILDER ID"
          value={personId}
          onChange={handleInputChange}
          placeholder="Enter NATIONBUILDER ID"
          type="text"
          slotProps={{
            input: {
              inputMode: "numeric",
            },
            htmlInput: { maxLength: 12 },
          }}
          margin="normal"
        />

        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={!personId.trim() || loading}
        >
          {loading ? <CircularProgress size={24} /> : "Search"}
        </Button>

        {noVersions && (
          <Alert severity="info" sx={{ mt: 2 }}>
            No versions found for this person.
          </Alert>
        )}
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          mt: 2,
        }}
      >
        {versions.map((version: ProfileVersionSchema) => (
          <ProfileVersion
            key={version.id}
            version={version}
            handleRollback={handleRollback}
          />
        ))}
      </Box>
    </Box>
  );
};

export default ProfileVersionsPage;
